<template>
  <b-card header-tag="header">
    <h3 slot="header">Schedule</h3>
    <h3 v-if="isLoading">Getting your schedule...</h3>
    <div class="card-text" v-if="isLoaded">
      <p><em>Last Updated: {{ lastRefreshDate }}</em> <b-button @click="refreshPage" variant="link"><em>Refresh</em></b-button></p>
      <div v-if="isTeamLeader">
        <div v-if="currentShifts.length > 0" class="row">
          <div class="col">
            <b-alert show variant="success">
              <h4>Current Shifts</h4>
              <b-list-group>
                <b-list-group-item :to="{ name: 'Shift', params: { id: cs.id }}" v-for="cs in currentShifts" :key="cs.id">
                  <!-- {{ cs.venue.name }} - {{ cs.venue.location }}<br> -->
                  {{ cs.venue.name }}<br>
                  {{ nextShiftDay(cs.day) }}<br>
                  {{ cs.start_time}} - {{ cs.end_time }} <br>
                  {{ cs.special }}
                </b-list-group-item>
              </b-list-group>
            </b-alert>
          </div>
        </div>
        <div class="row" v-if="nextShifts.length > 0">
          <div class="col">
            <b-alert show variant="warning">
              <h4>Next Shifts</h4>
              <b-list-group>
                <b-list-group-item :to="{ name: 'Shift', params: { id: ns.id }}" v-for="ns in nextShifts" :key="ns.id">
                  <!-- {{ ns.venue.name }} - {{ ns.venue.location }}<br> -->
                  {{ ns.venue.name }}<br>
                  {{ nextShiftDay(ns.day) }}<br>
                  {{ ns.start_time}} - {{ ns.end_time }} <br>
                  {{ ns.special }}
                </b-list-group-item>
              </b-list-group>
            </b-alert>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row">
          <div v-if="isScheduled && nextShift" class="col">
            <b-alert show variant="warning">
              <h4>Next Shift: {{ nextShiftDay(nextShift.day) }} - {{ nextShift.start_time}}</h4>
              <!-- <p>{{ nextShift.venue.name }} - {{ nextShift.venue.location}}</p> -->
              <p>{{ nextShift.venue.name }}</p>
              <p>{{nextShift.special}}</p>
              <p>Start: {{ nextShift.start_time}} <br>End: {{ nextShift.end_time }}</p>
            </b-alert>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <b-button @click="goToSchedule" class="btn btn-lg btn-black">View Schedule</b-button>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import moment from 'moment-timezone'
  import router from '@/router'
  export default {
    name: 'Schedule',
    data () {
      return {
        upcomingShift: {}
      }
    },
    methods: {
      nextShiftDay: function (day) {
        // if (moment().tz('America/Los_Angeles').isSame(moment.tz(moment(day).utc().format('YYYY-MM-DD'), 'America/Los_ANgele'), 'day')) {
        //   return 'Today'
        // } else {
          // return moment(day).utc().format('ddd MMM Do')
        // }
        console.log(day)
        return moment(day).utc().format('ddd MMM Do')
      },
      goToSchedule: function () {
        if (this.isTeamLeader) {
          router.push('/schedule/tl')
        } else {
          router.push('/schedule/sv')
        }
      },
      goToShiftSwapRequests: function () {
        router.push('/schedule/swap/list')
      },
      formattedDay: function (day) {
        return moment(day).utc().format('ddd MMM Do')
      },
      refreshPage: function () {
        location.reload()
      }
    },
    computed: {
      ...mapState('schedule', [
        'isLoading',
        'isLoaded',
        'shiftSwapRequestsLoaded',
        'shiftSwapRequests',
        'lastRefreshDate'
      ]),
      ...mapState('user', ['isTeamLeader']),
      ...mapGetters('schedule', [
        'nextShift',
        'isScheduled',
        'nextShifts',
        'currentShifts',
        'hasCreatedRequests',
        'hasAssignedRequests',
        'hasShiftRequests',
        'hasOpenRequests',
        'getQualifyingOpenRequests'
      ]),
      hasCreatedRequestNotifications: function () {
        if (this.hasCreatedRequests) {
          let has = this.shiftSwapRequests.createdRequests.find(r => {
            return r.accepted !== null
          })
          if (has !== undefined) {
            return true
          }
          return false
        }
        return false
      },
      hasAssignedRequestNotifications: function () {
        if (this.hasAssignedRequests) {
          let has = this.shiftSwapRequests.assignedRequests.find(r => {
            return r.accepted === null
          })
          if (has !== undefined) {
            return true
          }
          return false
        }
        return false
      }
    },
    created: function () {
      if (!this.$store.state.schedule.isLoaded) {
        this.$store.dispatch('schedule/load')
      }
    }
  }
</script>

<style scoped>
  .card {
    margin: 10px 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Schedule.vue